import { useArtifactStore, type ArtifactEntry } from '../hooks/useArtifactStore';

/**
 * Upserts an artifact and opens it in the workspace panel (callable outside React).
 * @param entry Artifact to display in ArtifactPanel
 */
export function pushArtifactToPanel(entry: ArtifactEntry): void {
  const { upsertArtifact, openInPanel } = useArtifactStore.getState();
  upsertArtifact(entry);
  openInPanel(entry.identifier);
}
